/**
 * Url для сервиса запроса на возврат денежных средств.
 */
export const refundRequestUrl = window.app && window.app.refundRequestUrl
